import { AnalysisResultCategoryEnum } from '../../../shared/models';

export const CHECK_ANALYSIS_RESULT_KEY_SEPARATOR = '__';

export const CHECK_ANALYSIS_RESULT_FRAUD_ANALYSIS_PREFIX = 'document_forensics';

export const CHECK_ANALYSIS_RESULT_DATA_COMPARISON_NAME_KEY = [
  AnalysisResultCategoryEnum.data_comparison,
  'name',
].join(CHECK_ANALYSIS_RESULT_KEY_SEPARATOR);

export const CHECK_ANALYSIS_RESULT_DATA_COMPARISON_BIRTH_DATE_KEY = [
  AnalysisResultCategoryEnum.data_comparison,
  'birth_date',
].join(CHECK_ANALYSIS_RESULT_KEY_SEPARATOR);

export const CHECK_ANALYSIS_RESULT_DOCUMENT_AGE_VALIDATION_KEY = [
  'document_age_in_days',
].join(CHECK_ANALYSIS_RESULT_KEY_SEPARATOR);

export const CHECK_ANALYSIS_RESULT_DOCUMENT_TYPE_VALIDATION_KEY = [
  'document_type',
].join(CHECK_ANALYSIS_RESULT_KEY_SEPARATOR);
